export function mapNullToUndefined<T>(item: T | null) {
  return item ?? undefined;
}

export const flipMap = <T extends string, R extends string>(map: Record<T, R>) =>
  Object.fromEntries(Object.entries(map).map(([key, value]) => [value, key]));
